import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="select-button-disable"
export default class extends Controller {
  static targets = ["select", "button", "textBox", "textBoxWrapper"]

  connect() {
    this.toggleTextBoxVisibility()
    this.toggleButton()
  }

  selectChanged() {
    this.toggleTextBoxVisibility()
    this.toggleButton()
  }

  toggleTextBoxVisibility() {
    if (!this.hasTextBoxWrapperTarget) return
    
    const selectValue = this.selectTarget.value
    
    if (selectValue === "other" || selectValue === "Other") {
      this.textBoxWrapperTarget.style.display = ''
    } else {
      this.textBoxWrapperTarget.style.display = 'none'
    }
  }

  toggleButton() {
    const selectValue = this.selectTarget.value
    let disabled = !selectValue || selectValue === "0"

    if (selectValue === "other" || selectValue === "Other") {
      const textBoxValue = this.hasTextBoxTarget ? this.textBoxTarget.value.trim() : ""
      disabled = textBoxValue === ""
    }

    if (disabled) {
      this.disableButton()
    } else {
      this.enableButton()
    }
  }

  enableButton() {
    this.buttonTarget.classList.remove("btn-disabled")
    this.buttonTarget.disabled = false
  }

  disableButton() {
    if (!this.buttonTarget.classList.contains("btn-disabled")) {
      this.buttonTarget.classList.add("btn-disabled")
    }
    this.buttonTarget.disabled = true
  }
}
